import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var extTrainingApprovalRes;
export const extTrainingApprovalTodo = createAsyncThunk('extTrainingApproval', async (data) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    // console.log(val)

    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'learner/external_training_approval',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "external_approval": data.approval_status,
                "external_id": data.external_id,
                "fk_user_id": data.user,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return extTrainingApprovalRes = res.data
    } catch (error) {
        return extTrainingApprovalRes = error.response.data
    }
})